// wallet-lane.ts - the pure decision behind the login widget's "Continue with
// wallet" lane. Extracted from bounded-login-widget.ts (which pulls in the DOM
// and the auth barrel, so it cannot be unit tested) following the same
// extract-a-pure-helper pattern as bounded-widget-ownership.ts.
//
// The subtlety this file exists for: an INJECTED wallet in the registry is
// evidence the user actually has a wallet, which is why detection alone turns
// the lane on. Solana Mobile's MWA wallet is NOT that: registerMwa() registers
// on ANY capable Android browser whether or not a wallet app is installed. If
// registration ran unconditionally, every Bounded app would grow a wallet
// button on every Android phone - breaking the opt-in default that
// walletLogin/isWalletLoginEnabled exist to protect. So MWA is only ever
// registered once the lane is already the app's choice, and can never be the
// thing that turns it on.
/**
 * Whether the widget shows the wallet lane at all. Hard-off wins over
 * everything; otherwise an explicit per-call value wins; otherwise auto: on
 * when the app opted in, or when a wallet was actually detected.
 */
export function isWalletLaneEnabled(input) {
    if (input.hardOff)
        return false;
    if (input.requested !== undefined)
        return input.requested;
    return input.detected > 0 || input.optedIn;
}
/**
 * Whether to register (and therefore offer) Solana Mobile's wallet: exactly
 * "would the lane be on with NOTHING detected". Stating it this way is the
 * guarantee - MWA can never count toward detection, so it can never be what
 * turns the lane on, only something the app already chose.
 */
export function shouldOfferSolanaMobileWallet(input) {
    return isWalletLaneEnabled(Object.assign(Object.assign({}, input), { detected: 0 }));
}
